import styled, { css } from 'styled-components'
import { mediaQueries } from '../../../providers/MediaQueryProvider'

export const Container = styled.div<{
  $variant: 'small' | 'regular' | 'medium' | 'large'
  $inner?: boolean
  $noMargin: boolean
}>`
  ${mediaQueries.tablet} {
    display: flex;
  }

  ${({ $inner }) =>
    $inner &&
    css`
      margin-top: var(--space-300) !important;
      margin-left: var(--space-900);
    `};

  ${({ $variant, $noMargin }) =>
    $variant === 'small' &&
    !$noMargin &&
    css`
      margin-top: var(--space-200);
    `};

  ${({ $variant, $noMargin }) =>
    $variant === 'regular' &&
    !$noMargin &&
    css`
      margin-top: var(--space-300);
    `};

  ${({ $variant, $noMargin }) =>
    $variant === 'medium' &&
    !$noMargin &&
    css`
      margin-top: var(--space-400);
    `};

  ${({ $variant, $noMargin }) =>
    $variant === 'large' &&
    !$noMargin &&
    css`
      margin-top: var(--space-800);
    `};

  &:first-of-type {
    margin-top: 0;
  }
`
